// Panel layout-specific JavaScript
// This replaces app/assets/javascripts/panel.js

import { ready } from "../modules/core";

// Export a function that initializes the panel layout
export function initialize() {
  console.log("Panel layout initialization function called");

  // Initialize Select2
  initializeSelect2();

  // Initialize Bootstrap modals and other components
  initializeBootstrapComponents();

  // Initialize draft article image functionality
  initializeDraftArticleImageFunctions();

  // Add event listeners for sidebar toggle
  document.querySelectorAll('#sidebarToggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const sidebar = document.getElementById('adminSidebar');
      const content = document.getElementById('content-wrapper');

      if (sidebar) {
        sidebar.classList.toggle('tw-admin-sidebar-collapsed');
      }

      if (content) {
        content.classList.toggle('tw-admin-content-with-collapsed-sidebar');
      }

      // Toggle the icon direction
      const icon = this.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-angle-left');
        icon.classList.toggle('fa-angle-right');
      }
    });
  });

  // Initialize any Chart.js charts if they exist
  initializeCharts();

  return true;
}

// Initialize Bootstrap components (modals, dropdowns, etc)
function initializeBootstrapComponents() {
  console.log("Initializing Bootstrap components with native JavaScript");

  // Handle modals with native JavaScript
  // Find all modal triggers
  const modalTriggers = document.querySelectorAll('[data-toggle="modal"]');
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const targetSelector = this.getAttribute('data-target');
      const modal = document.querySelector(targetSelector);

      if (modal) {
        console.log("Modal trigger clicked for", targetSelector);
        // Add show class to modal and backdrop
        modal.classList.add('show');
        modal.style.display = 'block';

        // Create backdrop if needed
        if (!document.querySelector('.modal-backdrop')) {
          const backdrop = document.createElement('div');
          backdrop.className = 'modal-backdrop fade show';
          document.body.appendChild(backdrop);
        }

        // Add class to body to prevent scrolling
        document.body.classList.add('modal-open');
      }
    });
  });

  // Handle closing modals
  document.querySelectorAll('[data-dismiss="modal"]').forEach(closeBtn => {
    closeBtn.addEventListener('click', function() {
      closeModal(this.closest('.modal'));
    });
  });

  // Close modal when clicking outside content
  document.querySelectorAll('.modal').forEach(modal => {
    modal.addEventListener('click', function(e) {
      if (e.target === this) {
        closeModal(this);
      }
    });
  });

  // Specifically for entity selector modal
  const entitySelectorModal = document.getElementById('entitySelectorModal');
  if (entitySelectorModal) {
    console.log("Entity selector modal found, ensuring proper initialization");

    const modalTriggers = document.querySelectorAll('[data-target="#entitySelectorModal"]');
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        console.log("Entity selector modal trigger clicked");
        // Show modal with native JS
        entitySelectorModal.classList.add('show');
        entitySelectorModal.style.display = 'block';

        // Create backdrop if needed
        if (!document.querySelector('.modal-backdrop')) {
          const backdrop = document.createElement('div');
          backdrop.className = 'modal-backdrop fade show';
          document.body.appendChild(backdrop);
        }

        // Add class to body to prevent scrolling
        document.body.classList.add('modal-open');
      });
    });
  }
}

// Helper function to close modals
function closeModal(modal) {
  if (modal) {
    modal.classList.remove('show');
    modal.style.display = 'none';

    // Remove backdrop
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop && backdrop.parentNode) {
      backdrop.parentNode.removeChild(backdrop);
    }

    // Remove class from body
    document.body.classList.remove('modal-open');
  }
}

// Initialize enhanced select elements - using Stimulus controller instead of Select2
function initializeSelect2() {
  console.log("Select2 functionality is now handled by the Stimulus select controller");

  // Find any legacy select2 elements that don't have a controller
  document.querySelectorAll('select.select2:not([data-controller*="select"])').forEach(select => {
    // Add the Stimulus controller to handle enhanced select functionality
    select.setAttribute('data-controller', 'select');
    select.setAttribute('data-select-placeholder-value', select.getAttribute('placeholder') || 'Select an option...');
  });
}

// Handle draft article image functionality (legacy support)
function initializeDraftArticleImageFunctions() {
  // Check if we have any legacy forms that don't use the Stimulus controller
  const legacyForms = document.querySelectorAll('form[action*="regenerate_section_image"]:not([data-controller="image-prompt"])');

  if (legacyForms.length === 0) {
    // If all forms are using the Stimulus controller, no need to set up window functions
    console.log("All image forms are using Stimulus controllers - skipping legacy initialization");
    return;
  }

  // Support legacy forms by setting up window functions
  console.log("Setting up legacy image form functions");

  // These functions are used in the draft article form
  window.updateImagePromptAndOrientation = function(index) {
    var imageTypeSelector = document.getElementById("section_" + index + "_image_type_selector");
    var orientationSelector = document.getElementById("section_" + index + "_orientation_selector");
    var imagePromptTextArea = document.getElementById("section_" + index + "_image_prompt");
    var inputPromptModifiedInput = document.getElementById("image_prompt_" + index + "_modified");

    if (imageTypeSelector && orientationSelector && imagePromptTextArea) {
      var selectedImageType = imageTypeSelector.options[imageTypeSelector.selectedIndex];
      if (inputPromptModifiedInput.value === "false") {
        var selectedImagePrompt = selectedImageType.getAttribute('data-image-prompt');
        imagePromptTextArea.value = selectedImagePrompt;
      }

      for (var i = 0; i < orientationSelector.options.length; i++) {
        if (orientationSelector.options[i].value === selectedImageType.getAttribute('data-orientation')) {
          orientationSelector.options[i].selected = true;
          break;
        }
      }
    }
  };

  window.updateImagePromptForStyle = function(index) {
    var styleSelector = document.getElementById("section_" + index + "_style_selector");
    var imagePromptTextArea = document.getElementById("section_" + index + "_image_prompt");
    var inputPromptModifiedInput = document.getElementById("image_prompt_" + index + "_modified");

    if (styleSelector && imagePromptTextArea) {
      var selectedStyle = styleSelector.options[styleSelector.selectedIndex];
      if (inputPromptModifiedInput.value === "false") {
        var selectedImagePrompt = selectedStyle.getAttribute('data-image-prompt');
        imagePromptTextArea.value = selectedImagePrompt;
      }
    }
  };

  window.setImagePromptModified = function(index) {
    var imagePromptModifiedInput = document.getElementById("image_prompt_" + index + "_modified");
    if (imagePromptModifiedInput) {
      imagePromptModifiedInput.value = "true";
    }
  };
}

// Initialize Chart.js charts if they exist (for legacy charts without Stimulus)
function initializeCharts() {
  // If Chart.js is not available, exit early
  if (!window.Chart) {
    console.log("Chart.js library not loaded - skipping chart initialization");
    return;
  }

  // Check for legacy charts (canvas elements without Stimulus controller parents)
  const legacyCharts = document.querySelectorAll('canvas[data-chart-type]:not([data-chart-target="canvas"])');

  if (legacyCharts.length === 0) {
    console.log("No legacy charts found - all charts using Stimulus controller");
    return;
  }

  console.log(`Found ${legacyCharts.length} legacy charts to initialize`);

  // Initialize legacy charts
  legacyCharts.forEach(canvas => {
    try {
      const chartType = canvas.getAttribute('data-chart-type');
      const chartData = JSON.parse(canvas.getAttribute('data-chart-data') || '{}');
      const chartOptions = JSON.parse(canvas.getAttribute('data-chart-options') || '{}');

      if (chartType && chartData) {
        new window.Chart(canvas, {
          type: chartType,
          data: chartData,
          options: chartOptions
        });
      }
    } catch (error) {
      console.error('Error initializing legacy chart:', error);
    }
  });
}

// Also initialize on page load using the ready function
ready(() => {
  console.log("Panel layout loaded via ready function");
  initialize();
});

// Export the module name for easier debugging
export const MODULE_NAME = 'panel';

// Default export for dynamic imports
export default {
  initialize,
  MODULE_NAME
};